<template>
  <div class="pb-12">
    <!--  <div style="position: absolute; top:0; z-index:998" class="w-100 d-flex justify-content-between align-items-center px-4">-->
    <!--    <v-toolbar-title>خانه</v-toolbar-title>-->
    <!--    <wallet></wallet>-->
    <!--  </div>-->

    <v-row justify="center" no-gutters>
      <v-col class="pa-2 d-flex align-center" cols="12" md="5">
        <find-menu-page />
      </v-col>

      <v-col class="pa-2" cols="12" md="5">
        <div class="h_iframe-aparat_embed_frame">
          <iframe
            allowFullScreen="true"
            mozallowfullscreen="true"
            src="https://www.aparat.com/video/video/embed/videohash/qpqa67t/vt/frame"
            webkitallowfullscreen="true"
          ></iframe>
        </div>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tabs"
      :show-arrows="$vuetify.breakpoint.smAndDown"
      class="services-tab-list mb-md-6"
      grow
      height="156"
    >
      <v-tabs-slider color="transparent" />

      <v-tab
        v-for="(item, i) in tabItems"
        :key="i"
        :href="`#mobile-tabs-5-${i + 1}`"
        class="primary--text align-center flex-column mx-2 white"
      >
        <v-icon :color="item.color" class="mb-2" x-large
          >mdi-{{ item.icon }}</v-icon
        >
        <span class="text-black-75 font-size-h6"
          ><b>{{ item.title }}</b></span
        >
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs" touchless>
      <v-tab-item :value="'mobile-tabs-5-1'" class="bg-color">
        <v-card class="bg-color">
          <v-card-title class="px-md-8">{{
            $t("home.selectSystem")
          }}</v-card-title>
          <v-row no-gutters>
            <v-col cols="12">
              <HomeService />
              <hr class="pb-4" />
            </v-col>

            <v-col class="pb-4 px-md-4" cols="12">
              <DashboardBaner />
            </v-col>

            <v-col class="pb-4 px-md-4" cols="12">
              <NewsSlider />
            </v-col>

            <!--                                    <div class=" mb-30 ml-2">-->
            <!--                    <Calender></Calender>-->
            <!--                                    </div>-->

            <v-col class="pb-10 px-md-4" cols="12">
              <Notes :plannings="plannings" @getData="getPlannings" />
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>

      <v-tab-item :value="'mobile-tabs-5-2'" class="bg-color">
        <v-card class="bg-color">
          <v-card-title>{{ $t("home.yourPoints") }}</v-card-title>
          <v-card-text>
            <v-col class="containsMedia">
              <div class="py-8 px-4">
                <PointsService
                  :point="
                    user.redeemable_points != null ? user.redeemable_points : 0
                  "
                />
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :value="'mobile-tabs-5-3'">
        <!--            <v-card >-->
        <!--              <v-card-title>کد های تخفیف</v-card-title>-->

        <v-tabs v-model="tabs2" background-color="white" left>
          <v-tab href="#all">{{ $t("home.all") }} </v-tab>
          <!--                  <v-tab>-->
          <!--                    <img src="media/service-logo/new-1/robot-land.webp" height="30" width="30" alt="">-->
          <!--                    <b>رباتلند</b>-->
          <!--                  </v-tab>-->
          <!--                  <v-tab class="rounded-pill">-->
          <!--                    <img src="media/service-logo/new-1/payamak-land.webp" height="30" width="30" alt="">-->
          <!--                    <b>پیامک لند</b>-->
          <!--                  </v-tab>-->
          <!--                  <v-tab>-->
          <!--                    <img src="media/service-logo/new-1/info-land.webp" height="30" width="30" alt="">-->
          <!--                    <b>اینفولند</b>-->
          <!--                  </v-tab>-->
          <v-tabs-items v-model="tabs2">
            <v-tab-item :value="'all'">
              <div class="py-5 bg-color">
                <CouponService />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>

        <!--            <v-card-text>-->
        <!--              &lt;!&ndash;                <v-col class="containsMedia">&ndash;&gt;-->
        <!--              <div class="py-8 mb-6">-->
        <!--&lt;!&ndash;                <CouponService></CouponService>&ndash;&gt;-->
        <!--              </div>-->
        <!--              &lt;!&ndash;                </v-col>&ndash;&gt;-->
        <!--            </v-card-text>-->
        <!--            </v-card>-->
      </v-tab-item>

      <v-tab-item :value="'mobile-tabs-5-4'" class="bg-color">
        <tutorials class="transparent" />
      </v-tab-item>
    </v-tabs-items>

    <b-modal
      id="modal-scrollable"
      :title="content ? content.title : ''"
      ok-only
      :ok-title="$t('home.confirm')"
      scrollable
    >
      <p class="my-4" v-html="content ? content.description : ''"></p>
    </b-modal>
  </div>
</template>

<script>
import Wallet from "@/view/pages/transactions/wallet";
import HomeService from "@/view/layout/home/HomeService";
import CouponService from "@/view/layout/home/CouponService";
import PointsService from "@/view/layout/home/PointsService";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DashboardBaner from "@/view/pages/ads/DashboardBaner";
import Notes from "@/view/pages/Notes/Notes";
import NewsSlider from "@/view/pages/News/NewsSlider";
import News from "@/view/pages/News/News";
import Calender from "@/view/layout/home/Calender";
import { mapGetters } from "vuex";
import Tutorials from "@/core/plugins/TitleRibbon/pages/tutorials";
import FindMenuPage from "@/core/plugins/TitleRibbon/components/list/findMenuPage.vue";
// import {mapState} from "vuex";
// import store from "@/core/services/store";

export default {
  name: "Home",

  components: {
    FindMenuPage,
    Tutorials,
    Calender,
    News,
    NewsSlider,
    Notes,
    DashboardBaner,
    CouponService,
    HomeService,
    Wallet,
    PointsService,
  },

  data() {
    return {
      tabs: null,
      tabs2: null,
      payamakUrl: "https://payamak-land.ir",
      content: [],
      plannings: [],
      showIcon: false,
      banners: [],
      text1: "https://payamak-land.ir",
      // tabItems:[],
    };
  },

  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
    this.getPopup();
    this.getPlannings();

    // this.tabItems = [
    //   {title: 'خانه', icon: 'home', color: '#6cdb72'},
    //   {
    //     title: `امتیازشما: ${this.user.redeemable_points != null
    //       ? this.persian(this.user.redeemable_points)
    //       : 0}`,
    //     icon: 'assistant',
    //     color: '#c9c700'
    //   },
    //   {title: 'تخفیف ها', icon: 'ticket-percent', color: '#a78d5b'},
    //   {title: 'راهنمای سامانه', icon: 'help', color: 'var(--v-orange-base)'},
    // ]
  },

  computed: {
    tabItems() {
      if (this.$i18n.locale === "fa")
        return [
          { title: this.$t("home.title"), icon: "home", color: "#6cdb72" },
          {
            title: this.$t("home.yourPointsDynamic", {
              points:
                this.user.redeemable_points != null
                  ? this.use_lang(this.user.redeemable_points)
                  : this.use_lang(0),
            }),
            icon: "assistant",
            color: "#c9c700",
          },
          {
            title: this.$t("home.discounts"),
            icon: "ticket-percent",
            color: "#a78d5b",
          },
          {
            title: this.$t("home.systemGuide"),
            icon: "help",
            color: "var(--v-orange-base)",
          },
        ];
      else {
        return [
          { title: this.$t("home.title"), icon: "home", color: "#6cdb72" },
          {
            title: this.$t("home.yourPointsDynamic", {
              points:
                this.user.redeemable_points != null
                  ? this.use_lang(this.user.redeemable_points)
                  : this.use_lang(0),
            }),
            icon: "assistant",
            color: "#c9c700",
          },
          {
            title: this.$t("home.discounts"),
            icon: "ticket-percent",
            color: "#a78d5b",
          },
        ];
      }
    },
    copyTextTitle() {
      return this.$t("home.copy");
    },
    user() {
      return this.$store.getters["user"];
    },
    ...mapGetters("tutorial", ["popups", "popupSlugs"]),
  },

  watch: {
    $route(to, from) {
      let popupExists = this.popupSlugs.indexOf(to.path.substring(1)) > -1;
      console.log(popupExists);
      if (popupExists) {
        let seen = localStorage.getItem("popups");
        console.log(seen);
      }
    },
  },

  // mounted() {
  //     window.document.querySelector("#kt_footer").classList.add("manamanam")
  // },

  methods: {
    getPopup() {
      this.requestApiGet("contentIndex?type=popup").then(({ data }) => {
        this.banners = data.data;
        this.content = data.data[0];

        // for (let i = 0; i < data.data; i++) {
        //     console.log(data.data[0])
        // }

        for (let i in data.data) {
          // localStorage.setItem(`popup${data.data[i].id}`,false)
          // this.content=data.data[i]
          // this.$bvModal.show('modal-scrollable');
          // this.$bvModal.show('modal-scrollable');
          // this.$bvModal.show('modal-scrollable');
        }

        // if (localStorage.getItem('popup') !== 'true') {
        //   this.$bvModal.show('modal-scrollable');
        // }
        // localStorage.setItem('popup', true);
      });
    },
    getPlannings() {
      this.requestApiGet("user/plannings").then(({ data }) => {
        this.plannings = [];

        for (let i in data) {
          if (typeof data[i] == "object") {
            data[i].inEditMode = false;
          }
        }
        this.plannings = data;
      });
    },

    getDashboard() {
      this.requestApiGet("content/1").then(({ data }) => {
        this.dashboard = data.description;
      });
    },

    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
  },
};
</script>

<style>
#kt_content {
  padding-top: 2em !important;
}

@media (min-width: 1264px) {
  .container {
    max-width: 1440px;
  }
}

@media (max-width: 960px) {
  .container {
    max-width: 900px;
  }
}

.h_iframe-aparat_embed_frame {
  position: relative;
  max-width: 270px;
  aspect-ratio: 16/9;
  margin-inline: auto;
}

.h_iframe-aparat_embed_frame .ratio {
  display: block;
  width: 100%;
  height: auto;
}

.h_iframe-aparat_embed_frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>

<style scoped>
.services-tab-list:deep(.v-tabs-bar) {
  background-color: unset !important;
  align-items: center;
}

.services-tab-list:deep(.v-tabs-bar__content) {
  justify-content: center;
  padding: 12px 0;
  height: 156px;
}

@media screen and (max-width: 960px) {
  .services-tab-list:deep(.v-tabs-bar__content) {
    height: 100px;
  }
}

.services-tab-list:deep(.v-tab) {
  max-width: 270px;
  width: 130px;
  box-shadow: 8px 5px 10px #f49d1a;
  border-radius: 16px;
  transition: all 0.3s ease-in-out;
}

.services-tab-list:deep(.v-tab--active) {
  background-color: var(--v-primary-base) !important;
  box-shadow: none !important;
}

@media screen and (min-width: 960px) {
  .services-tab-list:deep(.v-tab:not(.v-tab--active):hover) {
    transform: translate3d(4px, -8px, 10px);
    /*box-shadow: 8px 5px 10px rgba(0, 0, 0, .6);*/
  }
}

.services-tab-list:deep(.v-tab--active),
.services-tab-list:deep(.v-tab--active .v-icon) {
  color: var(--v-warning-base) !important;
}

.services-tab-list:deep(.v-slide-group__prev),
.services-tab-list:deep(.v-slide-group__next) {
  height: 32px;
  min-width: 32px !important;
  border-radius: 50%;
  background-color: white;
  margin: 0 4px;
}

.services-tab-list:deep(.v-slide-group__prev.v-slide-group__prev--disabled),
.services-tab-list:deep(.v-slide-group__next.v-slide-group__next--disabled) {
  background-color: rgba(255, 255, 255, 0.3);
}

.fa-paper-plane {
  color: #725ac1;
}

.bg-color {
  background-color: rgb(238, 240, 248);
}

.fa-robot {
  color: #f44336;
}

/*.full-width {*/
/*    position: absolute;*/
/*    left: 6vw;*/
/*    right: 4vw;*/
/*    width: 90vw;*/
/*    !*margin-right: -237px;*!*/
/*    !*position: absolute;*!*/
/*}*/
</style>
